<template>
  <v-layout column>
    <v-data-table :items="transactions" :headers="headers" must-sort>
      <template slot="items" slot-scope="props">
        <td>{{ props.item.createdAt | formatDate }}</td>
        <td>{{ props.item.amount | toDollar }}</td>
      </template>
    </v-data-table>
  </v-layout>
</template>

<script>
import dayjs from 'dayjs';
import { db, getUid } from '@/plugins/firebase';
import { toDollar } from '@/util';

export default {
  name: 'Transactions',
  filters: {
    formatDate: date => date && dayjs(date).format('h:mm A MM/DD/YYYY'),
    toDollar,
  },
  data: () => ({
    transactions: [],
    headers: [
      {
        text: 'Date',
        align: 'left',
        value: 'createdAt',
      },
      {
        text: 'Amount',
        value: 'amount',
      },
    ],
  }),
  firestore: {
    transactions: db
      .collection('transactions')
      .where('tenant', '==', getUid()),
  },
};
</script>

<style></style>
